<template>
    <div id="adDisclosureModal" role="dialog" tabindex="-1" class="modal fade" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content" v-html="modalData"></div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from 'vue'
import apiClient from '../services/apiClient'

export default defineComponent({
    data() {
        return {
            modalData: ""
        }
    },
    created() {
        this.getAdDisclosureAjaxCall();
    },
    methods:{
        async getAdDisclosureAjaxCall() {
            this.modalData = await apiClient.getAdDisclosure();
            
            this.$nextTick(()=>{
                var dateNowElems = document.querySelectorAll("[id='dateNow']");
                dateNowElems.forEach((x) => {
                    x.innerHTML = new Date().toLocaleDateString();
                });
                (document.getElementsByClassName("closeButton")[0] as any).onclick = () =>{  (jQuery("#adDisclosureModal") as any).modal('hide');};
            })
        }
    }
})
</script>
<style lang="scss">
#adDisclosureModal {
    .modalHeader {
        font-family: Arial;
        a.closeButton{
            color: #fff;
            text-decoration: none;
        }
    }

    .modalBody p{
        font-family: Arial;
    }
    .modal-dialog {
        transform: none;
    }
}
</style>